module.exports = __webpack_public_path__ + "af7258c25cb1626fe99db154ff84276d.svg";